// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__InAPu","pagination":"style_pagination__vc6ci"};